import { ViewModel } from './model';
import html from './template.html';
import './style.less';

ko.components.register('first-click-areas-sidesheet', {
  viewModel: {
    createViewModel: (params, componentInfo) => {
      let element = componentInfo.element;
      element.classList.add('first-click-areas-sidesheet');
      return new ViewModel(params, element);
    },
  },
  template: html,
});
